import { KeyRound, Car, Lock, Unlock } from "lucide-react";

export const PHONE_DISPLAY = "+420 608 359 395";
export const PHONE_RAW = "tel:+420608359395";
export const ADDRESS = "Oty Synka 1876/8, 708 00 Ostrava 8";
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Oty+Synka+1876%2F8%2C+708+00+Ostrava";

export const NAV_ITEMS = [
  { label: "Služby", id: "sluzby" },
  { label: "Autoklíče", id: "autoklice" },
  { label: "O nás", id: "o-nas" },
  { label: "Reference", id: "recenze" },
  { label: "Kontakt", id: "kontakt" },
];

export const SERVICES = [
  {
    icon: KeyRound,
    title: "Výroba klíčů",
    text: "Kopie běžných i bezpečnostních klíčů podle typu a dostupnosti polotovaru.",
    img: "/images/hero/hero-3.jpg",
    slug: "vyroba-klicu",
    href: "/vyroba-klicu",
  },
  {
    icon: Car,
    title: "Autoklíče",
    text: "Výroba, opravy, výměna obalů, baterií a řešení problémů s dálkovým ovládáním.",
    img: "https://images.unsplash.com/photo-1710006548781-eff5670376fa?auto=format&fit=crop&w=1200&q=80",
    slug: "autoklice",
    href: "/autoklice",
  },
  {
    icon: Lock,
    title: "Zámky a vložky",
    text: "Pomoc se zámky, vložkami a běžnými problémy kolem zabezpečení dveří.",
    img: "https://images.unsplash.com/photo-1563845104292-41c1b4825255?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxsb2NrJTIwY3lsaW5kZXIlMjBsb2NrJTIwd29ya3xlbnwwfHx8fDE3ODU1ODUzOTB8MA&ixlib=rb-4.1.0&q=85&w=1200",
    slug: "zamky-a-vlozky",
    href: "/zamky-a-vlozky",
  },
  {
    icon: Unlock,
    title: "Nouzové otevírání",
    text: "Pomoc při zabouchnutých nebo ztracených klíčích podle konkrétní situace.",
    img: "https://images.unsplash.com/photo-1677951570313-b0750351c461?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxsb2NrJTIwY3lsaW5kZXIlMjBsb2NrJTIwd29ya3xlbnwwfHx8fDE3ODU1ODUzOTB8MA&ixlib=rb-4.1.0&q=85&w=1200",
    slug: "nouzove-otevirani",
    href: "/nouzove-otevirani",
  },
];

export const SERVICE_LINKS = SERVICES.map((s) => ({
  label: s.title,
  href: s.href,
  icon: s.icon,
}));

export const SERVICE_PAGES = {
  "vyroba-klicu": {
    icon: KeyRound,
    h1: "Výroba klíčů",
    heroImg:
      "/images/hero/hero-3.jpg",
    intro:
      "Vyrábíme širokou škálu klíčů pro domácnosti, firmy, auta i běžné každodenní použití. Přijďte s původním klíčem a podle typu klíče vám připravíme kopii rychle a přesně.",
    listTitle: "Vyrábíme klíče",
    list: [
      "dozické",
      "k visacím zámkům",
      "tvarové",
      "bezpečnostní",
      "trezorové",
      "autoklíče",
      "motoklíče",
      "důlkové",
      "schránkové",
      "nábytkové",
    ],
    seoTitle: "Výroba klíčů Ostrava | Klíče Ostrava",
    seoDesc:
      "Výroba klíčů v Ostravě. Kopie běžných, bezpečnostních, schránkových, nábytkových i dalších typů klíčů.",
  },
  autoklice: {
    icon: Car,
    h1: "Autoklíče",
    heroImg:
      "https://images.unsplash.com/photo-1533558701576-23c65e0272fb?auto=format&fit=crop&w=1600&q=80",
    intro:
      "Užívejte si klidné cesty. Starosti s vaším autoklíčem nechte na nás. Využíváme moderní stroje, technologie i dlouholeté zkušenosti.",
    listTitle: "Co pro vás zajistíme",
    list: [
      "výroba nového klíče (bez čipu, s čipem, s dálkovým ovládáním)",
      "vyříznutí planžety",
      "oprava klíče (výměna obalu, letování spínačů, výměna baterií)",
      "oprava autozámků",
      "diagnostika autoklíče",
      "služba je na počkání (cca 15–60 minut)",
      "rezervace termínu on-line",
      "parkoviště",
      "přesné řezání klíčů dle technických výkresů na specializovaných strojích",
      "odborné poradenství",
    ],
    seoTitle: "Autoklíče Ostrava | Výroba a oprava autoklíčů",
    seoDesc:
      "Výroba a oprava autoklíčů v Ostravě. Výměna baterií, obalů, planžet, diagnostika a řešení problémů s dálkovým ovládáním.",
  },
  "zamky-a-vlozky": {
    icon: Lock,
    h1: "Zámky a vložky",
    heroImg:
      "https://images.unsplash.com/photo-1563845104292-41c1b4825255?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxsb2NrJTIwY3lsaW5kZXIlMjBsb2NrJTIwd29ya3xlbnwwfHx8fDE3ODU1ODUzOTB8MA&ixlib=rb-4.1.0&q=85&w=1600",
    intro:
      "Pomůžeme vám s výběrem, výměnou a řešením běžných problémů se zámky a cylindrickými vložkami. Pracujeme s ověřenými značkami a pomůžeme najít vhodné řešení pro byt, dům i komerční prostor.",
    listTitle: "Značky a služby",
    list: [
      "FAB",
      "Abus",
      "Mul-T-Lock",
      "EVVA",
      "Yale",
      "cylindrické vložky",
      "bezpečnostní vložky",
      "zámky do dveří",
      "výměna vložky",
      "poradenství s výběrem",
    ],
    seoTitle: "Zámky a vložky Ostrava | Výměna a poradenství",
    seoDesc:
      "Zámky a cylindrické vložky v Ostravě. Pomoc s výběrem, výměnou a řešením problémů se zámky.",
  },
  "nouzove-otevirani": {
    icon: Unlock,
    h1: "Nouzové otevírání",
    heroImg:
      "https://images.unsplash.com/photo-1749477417968-2bc986bc6a42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMG1ldGFsd29ya2luZyUyMGxvY2tzbWl0aCUyMHdvcmtzaG9wfGVufDB8fHx8MTc4MzA4MDcxNnww&ixlib=rb-4.1.0&q=85&w=1600",
    intro:
      "Zabouchnuté nebo zamčené dveře dokážou zkomplikovat celý den. Pomůžeme vám podle konkrétní situace s otevřením bytu, domu, automobilu nebo komerčního objektu. Ozvěte se nám a domluvíme rychlé řešení.",
    listTitle: "S čím pomůžeme",
    list: [
      "Otevírání zavřených dveří bytu nebo domu.",
      "Otevírání zavřených dveří automobilu.",
      "Otevírání zavřených dveří komerčního objektu.",
      "Otevírání dveří mimo standardní pracovní dobu (noční a víkendové hodiny).",
    ],
    seoTitle: "Nouzové otevírání dveří Ostrava | Byty, domy, auta",
    seoDesc:
      "Nouzové otevírání dveří v Ostravě. Pomoc při zabouchnutých dveřích bytu, domu, auta nebo komerčního objektu.",
  },
};

export const HERO_CLUSTER = [
  {
    url: "/images/hero/hero-1.jpg",
    alt: "Detail autoklíče a dálkového ovladače",
  },
  {
    url: "/images/hero/hero-2.jpg",
    alt: "Výroba a kopírování klíče",
  },
  {
    url: "/images/hero/hero-3.jpg",
    alt: "Práce se zámkem a cylindrickou vložkou",
  },
];

export const HERO_BG =
  "https://images.pexels.com/photos/18101862/pexels-photo-18101862.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export const PROCESS = [
  {
    num: "01",
    title: "Zavolejte nebo přijďte",
    text: "Řekněte nám, co potřebujete – klíč, autoklíč, zámek nebo nouzovou pomoc. Poradíme hned na místě.",
  },
  {
    num: "02",
    title: "Posoudíme řešení",
    text: "Zkontrolujeme typ klíče, ovladače nebo vložky a najdeme nejrychlejší a nejlevnější variantu.",
  },
  {
    num: "03",
    title: "Vyrobíme a opravíme",
    text: "Většinu klíčů zvládneme na počkání. U autoklíčů naprogramujeme a otestujeme funkčnost.",
  },
  {
    num: "04",
    title: "Odjíždíte spokojeni",
    text: "Předáme hotovou zakázku, vysvětlíme funkce a poradíme s údržbou. Kávu na cestu máte u nás zdarma.",
  },
];

export const REVIEWS = [
  {
    name: "Petr Zajíček",
    stars: 5,
    date: "Google recenze",
    text: "Pan klíčař byl velmi ochotný, profesionální a celá práce mu trvala sotva pár minut. Všechny nově vyřezané klíče fungují naprosto bez problémů a nikde nedrhnou. Ceny jsou navíc velmi příznivé. Pokud hledáte spolehlivost, rychlost a precizní práci, rozhodně doporučuji!",
  },
  {
    name: "Lenka Doležalová",
    stars: 5,
    date: "Google recenze",
    text: "Skvělá zkušenost od začátku až do konce! Velmi ochotní a profesionální. Klíč byl vyroben rychle, přesně a za rozumnou cenu. Mohu s čistým svědomím doporučit každému, kdo hledá spolehlivou a profesionální službu. Určitě se sem v případě potřeby vrátím.👍",
  },
  {
    name: "Pavel Borák",
    stars: 5,
    date: "Google recenze",
    text: "Profesionální majitel, skvělá služba na počkání. Kopie klíče funguje v zámku hladce. Ze sedmáku příjemná procházka.",
  },
  {
    name: "Radek Pechy5",
    stars: 5,
    date: "Google recenze",
    text: "Skvělý servis, doporučuji!",
  },
];

export const FOTOPAS = [
  "https://images.unsplash.com/photo-1749477417968-2bc986bc6a42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMG1ldGFsd29ya2luZyUyMGxvY2tzbWl0aCUyMHdvcmtzaG9wfGVufDB8fHx8MTc4MzA4MDcxNnww&ixlib=rb-4.1.0&q=85&w=600",
  "/images/hero/hero-1.jpg",
  "/images/foto-1.jpg",
  "https://images.unsplash.com/photo-1533558701576-23c65e0272fb?auto=format&fit=crop&w=600&q=80",
  "/images/hero/hero-2.jpg",
  "/images/hero/hero-3.jpg",
  "/images/foto-2.jpg",
  "/images/foto-3.jpg",
];

export const HOURS = [
  { d: "Pondělí – Pátek", h: "12:00 – 18:00" },
  { d: "Sobota", h: "8:00 – 12:00" },
  { d: "Neděle", h: "Zavřeno" },
];
